// Dinheiro em CENTAVOS (contrato do backend: `*_cents`, BIGINT). Exibição pt-BR "R$ 1.234,56".
// Máscara "por dígitos": o usuário digita só números e o valor cresce da direita para a esquerda
// (1 → 0,01; 12 → 0,12; 123456 → 1.234,56) — sem precisar digitar vírgula no celular.

/** Centavos → "1.234,56" (sem o símbolo). Vazio para indefinido. */
export const centsToInput = (cents?: number | null): string => {
  if (cents === undefined || cents === null || !Number.isFinite(cents)) return '';
  const abs = Math.abs(Math.round(cents));
  const int = Math.floor(abs / 100).toLocaleString('pt-BR');
  const frac = String(abs % 100).padStart(2, '0');
  return `${cents < 0 ? '-' : ''}${int},${frac}`;
};

/** Centavos → "R$ 1.234,56"; "—" para indefinido. */
export const formatBRL = (cents?: number | null): string => {
  const text = centsToInput(cents);
  return text ? `R$ ${text}` : '—';
};

/**
 * Texto digitado (com máscara ou colado, ex.: "R$ 1.234,56" ou "123456") → centavos.
 * Considera só os dígitos: os dois últimos são os centavos. Vazio → null.
 */
export const inputToCents = (raw: string): number | null => {
  const digits = raw.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
  if (digits === '') return null;
  return Number(digits);
};

/** Aplica a máscara ao texto digitado: devolve o que mostrar e os centavos correspondentes. */
export const maskMoney = (raw: string): { display: string; cents: number | null } => {
  const cents = inputToCents(raw);
  return { display: cents === null ? '' : centsToInput(cents), cents };
};
